module.exports = __webpack_public_path__ + "img/indu_active_16.5000953b.png";